// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --white-color: #FFFFFF;
    --black-color: #000000;
    --escuro-azul-color: #252D3D;
    --escuro-azul2-color: #171e2e;
    --claro-verde-color: #33AB79;
    --escuroAzulMid1: #273137;
    --escuroAzulBright: #1E3949;
    --whiteNw-pastel-color: #FFFBF5;
    
    /* VENDAS */
    --Vendaverde-mid-color: #009688;
    --Vendaazul-mid-color: #2196F3;
    --Vendaverde-claro-color: #80D383;
    --Vendalaranja-mid-color: #F9A825;




    --Pedidos-color: #009688;
    --Trocas-color: #F9A825;
    --Entrada-color: #80D383;
    --Devolucao-color: #2196F3;
} 
`, "",{"version":3,"sources":["webpack://./src/assets/css/colors.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;IAC3B,+BAA+B;;IAE/B,WAAW;IACX,+BAA+B;IAC/B,8BAA8B;IAC9B,iCAAiC;IACjC,iCAAiC;;;;;IAKjC,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;AAC9B","sourcesContent":[":root{\r\n    --white-color: #FFFFFF;\r\n    --black-color: #000000;\r\n    --escuro-azul-color: #252D3D;\r\n    --escuro-azul2-color: #171e2e;\r\n    --claro-verde-color: #33AB79;\r\n    --escuroAzulMid1: #273137;\r\n    --escuroAzulBright: #1E3949;\r\n    --whiteNw-pastel-color: #FFFBF5;\r\n    \r\n    /* VENDAS */\r\n    --Vendaverde-mid-color: #009688;\r\n    --Vendaazul-mid-color: #2196F3;\r\n    --Vendaverde-claro-color: #80D383;\r\n    --Vendalaranja-mid-color: #F9A825;\r\n\r\n\r\n\r\n\r\n    --Pedidos-color: #009688;\r\n    --Trocas-color: #F9A825;\r\n    --Entrada-color: #80D383;\r\n    --Devolucao-color: #2196F3;\r\n} \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
